import React from 'react';

const Badge = ({ count, children, className = "" }) => {
  return (
    <div className="relative inline-block">
      {children}
      {count > 0 && (
        <span 
          className="absolute top-2 left-full -translate-y-full -translate-x-[25%] bg-red-500 text-white text-[11px] h-[18px] px-[6px] rounded-full flex items-center justify-center font-bold leading-none ml-1"
        >
          {count}
        </span>
      )}
    </div>
  );
};

export default Badge;
